import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountTodoItem } from './account-todos.types';

type StatusKey = 'open' | 'done';

/**
 * The account page's Pendenzen area (pure view).
 *
 * The Pendenzen of ONE account, in the register's look: Zielgruppe chips, due date, the assignee's
 * avatar and the round «Erledigt» check. A row click opens the Pendenz; «Neue Pendenz» asks the host
 * for the create dialog.
 *
 * Controlled: the list and every write come from the host. Only the Offen/Erledigt pill lives here.
 */
@Component({
    selector: 'abcp-account-todos',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './account-todos.component.html',
    styleUrls: ['./account-todos.component.scss'],
})
export class AbcpAccountTodosComponent {
    @Input() items: AccountTodoItem[] = [];
    @Input() loading = false;
    @Input() error = false;

    @Output() rowOpen = new EventEmitter<string>();
    /** `done` is the state the Pendenz should get. */
    @Output() doneToggle = new EventEmitter<{ id: string; done: boolean }>();
    @Output() createRequested = new EventEmitter<void>();
    /** The link icon of a Pendenz with a highlighted spot: show that spot again. */
    @Output() anchorOpen = new EventEmitter<AccountTodoItem>();
    @Output() retryRequested = new EventEmitter<void>();

    public status: StatusKey = 'open';
    public readonly statuses: readonly StatusKey[] = ['open', 'done'];

    public get shown(): AccountTodoItem[] {
        return this.items.filter((item) => (this.status === 'done' ? item.done : !item.done));
    }

    public countOf(status: StatusKey): number {
        return this.items.filter((item) => (status === 'done' ? item.done : !item.done)).length;
    }

    public statusLabelKey(status: StatusKey): string {
        return status === 'open' ? 'aumico_abcp_notes_filter_open' : 'aumico_abcp_notes_filter_done';
    }

    public onRowOpen(item: AccountTodoItem): void {
        this.rowOpen.emit(item.id);
    }

    public onDoneToggle(item: AccountTodoItem, event: Event): void {
        // The check sits inside the clickable row; without this the row would open as well.
        event.stopPropagation();
        this.doneToggle.emit({ id: item.id, done: !item.done });
    }

    public trackById(_: number, item: AccountTodoItem): string {
        return item.id;
    }
}
